<!-- 兴趣爱好 -->

<template>
  <div class="applyInitiation_personal applyInitiation_interest">
    <div class="applyInitiation_personal_head">
      <span>兴趣爱好</span>
      <span class="red">(必填)</span>
    </div>
    <div class="applyInitiation_personal_main">
      <ul class="applyInitiation_personal_list clearfix">
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">运动爱好</div>
          <el-select :disabled="isDisabled" v-model="selectedExercise" multiple collapse-tags placeholder="请选择">
            <el-option v-for="(item, index) in exerciseList" :key="index" :label="item.sc_name" :value="item.sc_name"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">爱好美食</div>
          <el-select :disabled="isDisabled" v-model="selectedCate" multiple collapse-tags placeholder="请选择">
            <el-option v-for="(item, index) in cateList" :key="index" :label="item.sc_name" :value="item.sc_name"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">旅游足迹</div>
          <el-select :disabled="isDisabled" v-model="selectedTravel" multiple collapse-tags placeholder="请选择">
            <el-option v-for="(item, index) in travelList" :key="index" :label="item.sc_name" :value="item.sc_name"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">自我描述</div>
          <el-select :disabled="isDisabled" v-model="selectedDesc" multiple collapse-tags placeholder="请选择">
            <el-option v-for="(item, index) in descList" :key="index" :label="item.sc_name" :value="item.sc_name"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">才艺/特长</div>
          <el-input :disabled="isDisabled" v-model="hobbyFormData.h_begood" placeholder="请输入"></el-input>
        </li>
      </ul>

      <div class="copy" @click="handleSubmitInterest" v-if="!isDisabled">保存并继续</div>
    </div>
  </div>
</template>

<script>
import $DB from '../../../util/debounce'

export default {
  name: 'Hobby',
  props: {
    // 用户信息
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hobbyInfo: { h_status: 0 },

      exerciseList: [], // 运动爱好列表
      cateList: [], // 美食列表
      travelList: [], // 旅游列表
      descList: [], // 自我介绍

      selectedExercise: [],
      selectedCate: [],
      selectedTravel: [],
      selectedDesc: [],

      hobbyFormData: {
        h_exercise: '', // 运动爱好
        h_cate: '', // 美食爱好
        h_travel: '', // 旅游足迹
        h_desc: '', // 自我介绍

        // 202406 新增
        h_begood: '', // 才艺特长
      },
    }
  },
  computed: {
    isDisabled() {
      return this.userInfo.check_status === 2 || this.userInfo.check_status === 3
    },
  },
  created() {
    this.funLoadUserHobby()

    const obj = {
      2: 'exerciseList', // 运动爱好列表
      3: 'cateList', // 美食列表
      4: 'travelList', // 旅游列表
      5: 'descList', // 自我介绍
    }
    for (const key in obj) {
      this.funLodeCateList(+key, obj[key])
    }
  },
  methods: {
    // 获取兴趣爱好
    funLoadUserHobby() {
      this.$axios.post('/api/member/getUserHobby').then((res) => {
        this.hobbyInfo.h_status = res.data.data.h_status
        if (res.data.code === 0) {
          this.hobbyInfo = res.data.data
          this.selectedExercise = res.data.data.h_exercise.split(',')
          this.selectedCate = res.data.data.h_cate.split(',')
          this.selectedTravel = res.data.data.h_travel.split(',')
          this.selectedDesc = res.data.data.h_desc.split(',')
          for (const key in this.hobbyFormData) {
            this.hobbyFormData[key] = this.hobbyInfo[key]
          }
        }
      })
    },

    /**
     * 获取下拉选择内容
     * @param {Number} type 类型
     * @param {String} propName data 中的字段名
     */
    funLodeCateList(type, propName) {
      this.$axios.post('/api/index/interList', { type }).then((res) => {
        if (res.data.code === 0) {
          if (type === 5) {
            this.descList = [...res.data.data.status1, ...res.data.data.status2, ...res.data.data.status3]
          } else {
            this[propName] = res.data.data
          }
        }
      })
    },

    // 提交兴趣爱好
    handleSubmitInterest: $DB(function () {
      if (!this.selectedExercise.length) return this.$message.error('请选择运动爱好')
      if (!this.selectedCate.length) return this.$message.error('请选择美食爱好')
      if (!this.selectedTravel.length) return this.$message.error('请选择旅游爱好')
      if (!this.selectedDesc.length) return this.$message.error('请选择自我介绍')
      // if (this.hobbyFormData.h_feel === '') return this.$message.error('请选择感情经历')
      if (!this.hobbyFormData.h_begood.trim()) return this.$message.error('请输入才艺特长')
      // if (!this.hobbyFormData.h_advantage.trim()) return this.$message.error('请输入自己的优势')
      // if (!this.hobbyFormData.h_tolerate.trim()) return this.$message.error('请输入需要对方包容的地方')

      this.hobbyFormData.h_exercise = this.selectedExercise.join(',')
      this.hobbyFormData.h_cate = this.selectedCate.join(',')
      this.hobbyFormData.h_travel = this.selectedTravel.join(',')
      this.hobbyFormData.h_desc = this.selectedDesc.join(',')

      // console.log({ ...this.hobbyFormData })
      // return

      this.$axios.post('/api/member/userHobby', this.hobbyFormData).then((res) => {
        if (res.data.code === 0) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }),
  },
}
</script>

<style lang="scss" src="../index.scss" scoped></style>
